import { BadgeCheck } from "lucide-react";

export default function VerifiedBadge({ size = 16, showText = false, className = "" }) {
  if (showText) {
    return (
      <span
        data-testid="verified-badge"
        className={`inline-flex items-center gap-1 text-[#1da1f2] font-medium text-xs bg-blue-50 px-2 py-0.5 rounded-full border border-blue-200 ${className}`}
      >
        <BadgeCheck size={14} className="fill-[#1da1f2] text-white" />
        Onaylı
      </span>
    );
  }
  return (
    <BadgeCheck
      data-testid="verified-badge"
      size={size}
      className={`fill-[#1da1f2] text-white shrink-0 ${className}`}
    />
  );
}
